module.exports = __webpack_public_path__ + "static/media/nav-my-documents-inquiries-active.4dc9dd35.svg";